var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"ma-0 pa-0",staticStyle:{"min-width":"0"},attrs:{"text":"","plain":"","ripple":false},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('input', !_vm.value)}}},[(_vm.value)?_c('v-icon',[_vm._v("mdi-arrow-left")]):_c('v-icon',[_vm._v("mdi-arrow-right")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }